import type { Fetcher } from "react-query-kit";
import { createQuery } from "react-query-kit";

import { getApi } from "@api/apiPath";
import { axiosClient } from "@api/clients.ts";
import type { IPublicStatisticsEndpoint } from "@api/system/publicStatistics/types";
import type { IApiResponse } from "@/api";

const { key, getPath } = getApi("system.publicStatistics.get");

const getPublicStatistics: Fetcher<IApiResponse<IPublicStatisticsEndpoint>> = (
  params,
) => {
  return axiosClient.get(getPath(), { params });
};

export const useGetPublicStatistics = createQuery({
  queryKey: [key],
  fetcher: getPublicStatistics,
});
